const _jsxFileName = "/home/runner/work/heinzerling-web/heinzerling-web/app/js/components/ErrorMessage.tsx";import React from "react";

import styled from "styled-components";

import { Icon } from "@opendash/icons";

const Container = styled.div`
  width: 100%;
  height: 200px;

  padding: 20px;

  display: flex;
  justify-content: center;
  align-items: center;

  text-align: center;
`;

const IconHolder = styled.div`
  font-size: 2em;
`;

const Title = styled.div`
  text-transform: uppercase;
  font-weight: 700;
`;

const Message = styled.div`
  margin-bottom: 10px;
`;








export const ErrorMessage = React.memo(function ErrorMessage({
  icon,
  iconClass,
  title,
  message,
}) {
  return (
    React.createElement(Container, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 47}}
      , React.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 48}}
        , React.createElement(IconHolder, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}
          , React.createElement(Icon, { icon: icon, className: iconClass, __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}} )
        )
        , React.createElement(Title, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}, title)
        , React.createElement(Message, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}, message)
      )
    )
  );
});
